/**
 * plp layout
 */
(() => {
  const plpPage = document.querySelectorAll('.ex-category, .ex-searchresult, .product-merch, .ex-content-page');
  if (!plpPage.length) return;

  plpPage.forEach((page) => {
    const breadcrumb = page.querySelector('.row-breadcrumb');
    page.querySelector('.zonetop').append(breadcrumb);
  });

  function updateTileParents() {
    const tileparent = document.querySelectorAll('.tileparent');
    tileparent.forEach((tile) => {
      if (tile.classList.contains('nLoaded')) return;
      tile.classList.add('nLoaded');
      const actionWrapper = document.createElement('div');
      const compare = tile.querySelector('.product-compare-action');
      const quicklist = tile.querySelector('.addtoquicklist-wrapper');
      if (compare && quicklist) {
        actionWrapper.innerHTML = /* html */ `
        <div class="action-wrapper">
          ${compare.outerHTML}
          ${quicklist.outerHTML}
        </div>
        `;
        tile.querySelector('.footer').appendChild(actionWrapper);
      }

      /**
       * call for availability button replace add to cart
       */
      // (() => {
      //   const updateButton = () => {
      //     const button = tile.querySelector('.buttons.group button');
      //     const input = tile.querySelector('.buttons.group input');
      //     const outOfStock = tile.querySelector('.live-outstock');
      //     if (button && outOfStock) {
      //       button.innerHTML = 'Call for Availability';
      //       button.classList.add('call-for-availability');
      //       if (input) {
      //         input.remove();
      //       }
      //     }
      //   };

      //   // Select the node that will be observed for mutations
      //   const targetNode = document.querySelector('.has-live-inventory');

      //   if (targetNode) {
      //     // Options for the observer (which mutations to observe)
      //     const config = { attributes: true };

      //     // Callback function to execute when mutations are observed
      //     const observer = new MutationObserver(() => {
      //       updateButton();
      //     });

      //     // Start observing the target node for configured mutations
      //     observer.observe(targetNode, config);
      //   }
      // })();
    });
  }

  updateTileParents();

  document.addEventListener('product-loadmore-success', () => {
    setTimeout(() => {
      updateTileParents();
    }, 1000);
  }, false);

  const imageError = () => {
    const placeholderUrl = 'https://us.evocdn.io/dealer/1407/content/media/My_Theme/ke-coming-soon-image.png'; // make sure this url works
    const images = document.querySelectorAll('.imgthumbnail img');
    images.forEach((image) => {
      if (image.src === 'https://keencompressedgas.us.evostore.io/img/picture-100.png') {
        image.src = placeholderUrl;
      }
    });
  };
  // document.addEventListener('product-loadmore-success', () => {
  //   setTimeout(() => { // To stop the code bugging out and replacing all images with the placeholder
  //     imageError();
  //   }, 10);
  // }, false);
  // document.addEventListener('live-inventory-done', () => { // Run code when inventory has loaded
  //   setTimeout(() => {
  //     imageError();
  //   }, 10);
  // }, false);
  setTimeout(() => { // Fallback in case inventory is removed
    imageError();
  }, 1);

  const catalogName = document.querySelector('.productsgrid_container .catalog-name');
  if (catalogName) {
    document.querySelector('.productsgrid_container .gridtools').prepend(catalogName);
  }
})();

/**
 * adding class to quicklist list
 */
(() => {
  const quicklist = document.querySelectorAll('.productgridfull.gridlist-list .product-shopping-actions-addtoquicklist');
  quicklist.forEach((item) => {
    item.parentNode.classList.add('addtoquicklist-wrapper');
  });
})();
